module.exports = __webpack_public_path__ + "img/exploringes6.2949256f.png";